import React, { useEffect, useState } from 'react';
import { CheckCircle } from 'lucide-react';
const purchases = [{
  name: 'María L.',
  location: 'Córdoba, Argentina'
}, {
  name: 'Juan P.',
  location: 'Santa Fe, Argentina'
}, {
  name: 'Ana M.',
  location: 'Buenos Aires, Argentina'
}, {
  name: 'Carlos R.',
  location: 'Mendoza, Argentina'
}, {
  name: 'Lucía G.',
  location: 'Entre Ríos, Argentina'
}, {
  name: 'Diego F.',
  location: 'La Pampa, Argentina'
}, {
  name: 'Sofía C.',
  location: 'Santiago del Estero, Argentina'
}, {
  name: 'Martín H.',
  location: 'Chaco, Argentina'
}];
export function SocialProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentPurchase, setCurrentPurchase] = useState(purchases[0]);
  useEffect(() => {
    const initialTimer = setTimeout(() => {
      showNextPopup();
    }, 5000);
    return () => clearTimeout(initialTimer);
  }, []);
  const showNextPopup = () => {
    const randomPurchase = purchases[Math.floor(Math.random() * purchases.length)];
    setCurrentPurchase(randomPurchase);
    setIsVisible(true);
    setTimeout(() => {
      setIsVisible(false);
      const nextDelay = Math.floor(Math.random() * 10000) + 10000;
      setTimeout(showNextPopup, nextDelay);
    }, 4000);
  };
  if (!isVisible) return null;
  return <div className="fixed bottom-4 left-4 z-50 animate-[slideIn_0.5s_ease-out] max-w-[280px] md:max-w-[300px]" data-id="element-258">
      <div className="bg-brand-card rounded-lg shadow-2xl border-2 border-brand-accent p-3 flex items-start gap-2.5 relative overflow-hidden" data-id="element-259">
        <div className="bg-brand-accent/20 p-1.5 rounded-full shrink-0" data-id="element-260">
          <CheckCircle className="w-5 h-5 text-brand-accent" data-id="element-261" />
        </div>
        <div data-id="element-262">
          <p className="text-xs md:text-sm text-gray-200 font-medium leading-tight mb-0.5" data-id="element-263">
            <span className="font-bold text-white" data-id="element-264">{currentPurchase.name}</span>{' '}
            de {currentPurchase.location} acaba de comprar el Kit Digital 🌾
          </p>
          <p className="text-[10px] text-brand-accent font-bold" data-id="element-265">
            Hace unos minutos
          </p>
        </div>
      </div>
      <style data-id="element-266">{`
        @keyframes slideIn {
          from { transform: translateX(-120%); opacity: 0; }
          to { transform: translateX(0); opacity: 1; }
        }
      `}</style>
    </div>;
}